import { Category } from '@propertypal/shared/src/types/siteMap';
import platform from '@propertypal/shared/src/utils/platform';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import Chevron from '../icons/Chevron';
import PageWrapper from '../layout/PageWrapper';
import { Heading, SubHeading, Text } from '../typography';
import { BackLink, ListItem, Section, TwoColumn, TwoColumnBox, TwoColumnList } from './SiteMapGlobal.style';

interface SiteMapData {
  data: Category[];
  letter: string;
}

const SiteMapTown: FunctionComponent<SiteMapData> = (props) => {
  const theme = useTheme();

  return (
    <>
      <Section>
        <PageWrapper>
          <BackLink href="/site-map" prefetch={false}>
            <Text color={theme.primary} fontSize={16}>
              <Chevron size={12} direction="left" /> Back to Site Map
            </Text>
          </BackLink>

          <Heading fontSize={32} fontWeight="300" mt={30}>
            {platform.domain.toUpperCase()} SITE MAP
          </Heading>
        </PageWrapper>
      </Section>
      <Section noBg>
        <PageWrapper>
          <SubHeading color={theme.primary} fontSize={22} fontWeight="300" mt={30} mb={30}>
            TOWN &amp; AREAS BEGINNING WITH {props.letter}
          </SubHeading>

          <TwoColumn>
            {props.data.map((town) => {
              return (
                <TwoColumnBox key={`${town.name}, ${town.links.toString()}`}>
                  <SubHeading fontSize={19} fontWeight="300">
                    {town.name.toUpperCase()}
                  </SubHeading>

                  <TwoColumnList>
                    {town.links.map((link) => {
                      return (
                        <ListItem key={link.label}>
                          <Link href={link.url} prefetch={false}>
                            <Text>{link.label}</Text>
                          </Link>
                        </ListItem>
                      );
                    })}
                  </TwoColumnList>
                </TwoColumnBox>
              );
            })}
          </TwoColumn>
        </PageWrapper>
      </Section>
    </>
  );
};

export default SiteMapTown;
